export default __webpack_public_path__ + "static/media/maze-versions.d81a5249.png";